<template>
  <div style="height:100%;">
    <el-row style="height:55px;">
      <SearchFilter :filter="filterOptions" @handleSearch="SearchWithFilter"></SearchFilter>
    </el-row>
    <el-row style="height:calc(100% - 55px - 42px);">
      <el-table :data="data" border style="width: 100%" height="100%">
        <el-table-column prop="result_name" label="电台类型" :width="100">
        </el-table-column>
        <el-table-column prop="frequency" label="频率" :width="60">
        </el-table-column>
        <el-table-column prop="upload_time" label="上传时间" :width="160">
        </el-table-column>
        <el-table-column prop="log_id" label="扫描终端" :width="160">
        </el-table-column>
        <el-table-column prop="recognition" label="语音识别">
        </el-table-column>
        <el-table-column label="录音文件" :width="100">
          <template slot-scope="scope">
            <el-button v-if="scope.row.radio_file_path" type="text" @click="$playAudio(scope.row.radio_file_path,scope.row.frequency,scope.row.upload_time)">点击播放</el-button>
            <template v-else>无文件</template>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row style="height:42px;padding-top:10px;">
      <Pagination ref="srPagination" totalCountOrURL="/radio/cnt_scanRecordAll" :params="queryParams" @change="handlePageChange"></Pagination>
    </el-row>

  </div>
</template>

<script>
  import Pagination from "@/components/PageNations/Pagination";
  import SearchFilter from "@/components/Input/SearchFilter";
  export default {
    components: {
      Pagination,
      SearchFilter
    },
    mounted() {
      // 初始化电台类型 和 设备号 选择项
      this.$getJSON("/admin/dictionary", {
        table: "fm_d_result_type"
      }).then(res => {

        let result_type = [];
        res.data.forEach(element => {
          result_type.push(element.name);
        });
        this.filterOptions.result_name.options = result_type;

        this.$getJSON("/admin/devicesByDistrict", {}).then(res => {
          let devices = {};
          res.data.forEach(element => {
            devices[element.district ? element.district : "其它"] = element.devices.split(",");
          });
          this.filterOptions.log_id.options = devices;

          this.getData();
        });
      });
    },
    data() {
      return {
        data: [],
        queryParams: {
          page: 1,
          size: 10
        },
        filterOptions: {
          result_name: {
            type: "select",
            text: "电台类型",
            width: "120px",
            placeholder: "请选择",
            options: null
          },
          frequency: {
            type: "real",
            text: "频率",
            width: "110px",
            placeholder: "请输入频率",
          },
          log_id: {
            type: "select2",
            text: "扫描终端",
            width: "160px",
            placeholder: "请选择",
            options: null
          },
          upload_time: {
            type: "datetimerange",
            text: "上传时间",
            width: "360px"
          }
        }
      };
    },
    methods: {
      SearchWithFilter(filter) {
        let options = [];
        if (filter.result_name && filter.result_name != "") {
          options.push({
            type: "1",
            name: "result_name",
            value: `'${filter.result_name}'`
          });
        }
        if (filter.frequency && filter.frequency != "") {
          options.push({
            type: "1",
            name: "frequency",
            value: filter.frequency
          });
        }
        if (filter.log_id && filter.log_id != "") {
          options.push({
            type: "1",
            name: "log_id",
            value: `'${filter.log_id}'`
          });
        }
        if (filter.upload_time && filter.upload_time.length > 0) {
          options.push({
            type: "4",
            name: "upload_time",
            value: [`'${filter.upload_time[0]}'`, `'${filter.upload_time[1]}'`]
          });
        }
        this.queryParams.options = options;
        this.queryParams.operator = " AND ";
        // 初始化页码
        this.queryParams.page = 1;
        // 更新导航条参数
        this.$refs["srPagination"].getTotalsize();
        this.getData();
      },
      handlePageChange(params) {
        this.queryParams.page = params.page;
        this.queryParams.size = params.size;
        this.getData();
      },
      getData() {
        this.$getJSON("/radio/s_scanRecordAll", this.queryParams).then(res => {
          this.data = res.data;
        });
      }
    }
  };

</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/pages/ScanRdAll.vue